<template>
  <div :class="{'calendar-disabled': disabled, 'full-height': type === 'sendingRules'}">
    <div class="row row-monthly" v-if="viewMode === 'monthly'">
      <div class="header" v-for="i in 7" :key="i">
        <div class="slds-text-heading_medium">
          <span>{{ $t(`days.long[${i - 1}]`) }}</span>
        </div>
      </div>
    </div>
    <div class="full-height">
      <div class="row" v-if="viewMode !== 'yearly'">
        <div
          class="day"
          :class="getClasses(day)"
          :ref="`day_${index}`"
          v-for="(day, index) in localDays" :key="index"
          @click="onDayClick(day)">
          <div class="header">
            <div class="slds-text-heading_medium" v-if="viewMode !== 'monthly'">
              <span>{{ getDayName(day) }}</span>
            </div>

            <article class="slds-card">
              <div v-if="type === 'exclusionSlots'">
                <span v-if="showDaysNumber">{{ day.dayNumber }}</span>
              </div>
              <div class="full-height" v-else-if="type === 'sendingRules' && $refs.day_0">
                <svg width="100%" :height="dayHeight">
                  <line v-for="row in 24" :key="row" x1="0" :y1="`${(row * 100) / 24}%`" x2="100%" :y2="`${(row * 100) / 24}%`" class="hour-row" />
                  <text :key="day + 0" x="2" :y="`${((1 * 100) / 24) - 1}%`" class="hour-number">00</text>
                  <text v-for="hour in 23" :key="day + hour" x="2" :y="`${(((hour + 1 ) * 100) / 24) - 1}%`" class="hour-number">{{ hour | asTwoDigits }}</text>
                  <rect v-if="getRectangles(day).length" x="0" :y="`${getRectangles(day)[0]}%`" :height="`${getRectangles(day)[1]}%`" width="100%" class="send-slot" />
                </svg>
              </div>
            </article>
          </div>
        </div>
      </div>
      <div class="row" v-else>
        <div class="day day-yearly" v-for="day in days" :key="day" @click="goToYear(day)">
          <div class="header full-height">
            <article class="slds-card full-height">
              <div class="full-height year-parent">
                <span class="slds-text-heading_medium">{{ day }}</span>
              </div>
            </article>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import moment from 'moment'
import { toggleInArray } from '../utils/utils'
export default {
  computed: {
    dayHeight () {
      return this.$refs.day_0[0].clientHeight * 0.95
    }
  },
  created () {
    this.fillLocalDays()

    this.$store.watch(
      (state, getters) => getters['session/locale'], () => { this.fillLocalDays() }
    )
  },
  data () {
    return {
      localDays: []
    }
  },
  methods: {
    calculatePercentage (hours, minutes) {
      return (parseInt(hours) * 60 + parseInt(minutes)) / (60 * 24) * 100
    },
    fillLocalDays () {
      this.localDays = this.days.map(day => {
        return {
          ...day.locale ? day.locale('en') : day,
          dayNumber: day.date ? day.date() : day,
          elements: this.elements ? this.elements.filter(element => this.filterDay(element, day)) : []
        }
      })
    },
    filterDay (element, day) {
      if (this.type === 'exclusionSlots') {
        return moment(element.date).isSame(moment(day), 'day')
      } else if (this.type === 'sendingRules') {
        const localizedDay = moment(day).locale(this.$store.getters['session/locale'])
        return this.$t(`days.eng.short.${element.inclusionDay}`) === localizedDay.format('ddd')
      }
    },
    getClasses (day) {
      return {
        [`day-${this.viewMode}`]: true,
        'next-month': this.isDifferentMonth(day),
        'exclusion-slot': this.type === 'exclusionSlots' && !this.disabled && day.elements.length
      }
    },
    getDayName (day) {
      const momentObject = moment(day).locale(this.$store.getters['session/locale'])
      return this.$t(`days.long[${momentObject.weekday()}]`)
    },
    getRectangles (day) {
      if (day.elements.length) {
        const element = day.elements[0]

        const splitStartHour = element.sendStartHour.split(':')
        const splitEndHour = element.sendEndHour.split(':')

        const startPercentageOfDay = this.calculatePercentage(splitStartHour[0], splitStartHour[1])
        const endPercentageOfDay = this.calculatePercentage(splitEndHour[0], splitEndHour[1])

        return [startPercentageOfDay, endPercentageOfDay - startPercentageOfDay]
      } else {
        return []
      }
    },
    goToYear (year) {
      this.$emit('yearChange', { year })
    },
    isDifferentMonth (day) {
      return this.viewMode === 'monthly' && moment(day).month() !== moment(this.lastSeen).month()
    },
    onDayClick (day) {
      if (this.type === 'exclusionSlots') {
        if (!this.isDifferentMonth(day) && !this.disabled) {
          this.$emit('dayClick', { day, action: day.elements.length ? 'remove' : 'add' })
        }
      } else if (this.type === 'sendingRules') {
        this.$emit('dayClick', { day: moment(day).format('ddd'), slot: day.elements[0] })
      }
    }
  },
  props: {
    days: Array,
    disabled: Boolean,
    elements: Array,
    lastSeen: Object,
    showDaysNumber: Boolean,
    type: String,
    viewMode: String
  },
  watch: {
    days () {
      this.fillLocalDays()
    },
    elements () {
      this.fillLocalDays()
    }
  }
}
</script>
<style lang="scss" scoped>
  .header {
    background-color: #F3F2F2;
    text-align: center;

    & > div {
      padding-top: 5px;
      padding-bottom: 5px;
    }
  }

  .calendar-container {
    display: flex;
    flex-direction: column;
    height: 100%;
  }
  .slds-media__body {
    text-align: center !important;
  }

  .full-height {
    height: 100%;
  }

  .exclusion-slot {
    background-color: red;
  }

  .row {
    display: flex;
    flex-direction: row;
    height: 100%;
    flex-wrap: wrap;

    & > div {
      flex-grow: 1;
    }
  }

  .row-monthly {
    height: auto !important;
  }

  .day {
    cursor: pointer;

    &:not(:last-child) {
      border-color: #DDDBDA;
      border-width: 1px;

      &:not(.day-yearly):not(:nth-child(7n)), &.day-yearly:not(:nth-child(4n)){
        border-right-style: solid;
      }
    }
  }

  .day-monthly {
    flex: 1 0 14.28%;
    &:not(:last-child) {
      border-bottom-style: solid;
    }
  }

  .day-weekly {
    flex: 1 0 14.28%;
  }

  .day-daily {
    flex: 1 0 100%
  }

  .day-yearly {
    flex: 1 0 25%;
    cursor: pointer;

    &:not(:last-child) {
      border-bottom-style: solid;
    }
  }

  .year-parent {
    position: relative;

    & > span {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }

    &:hover {
      background: #F3F2F2;
    }
  }

  .slds-card > div {
    user-select: none;
  }

  .next-month {
    opacity: 0.5
  }

  .calendar-disabled {
    opacity: 0.2;
  }

  .send-slot {
    fill: green;
    opacity: .4;
  }

  .hour-row {
    stroke: #ececec;
    stroke-width: 1;
  }

  .hour-number {
    fill: #aeaeae;
  }
</style>
